import { render, staticRenderFns } from "./settingGoodsDialog.vue?vue&type=template&id=78a83dcb"
import script from "./settingGoodsDialog.vue?vue&type=script&lang=js"
export * from "./settingGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./settingGoodsDialog.vue?vue&type=style&index=0&id=78a83dcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports